import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { SharedService } from '../../core/middleware-call/shared.service';


@Injectable({
    providedIn: 'root',
})
export class PublicGuardService implements CanActivate {

    constructor(
        private router: Router,
        private sharedService: SharedService) {
    }
    //Call the UserConditionsFineService to check if the user has checks required
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

        return new Promise((resolve) => {
            this.sharedService.getRole().subscribe(result => {
                if (result.role == 'AFF') {
                    this.router.navigate(['/affiliate']);
                    resolve(false);
                    //return false; // poc
                }
                else if (result.role == 'RH') {
                    this.router.navigate(['/rh']);
                    resolve(false);
                }
                else {
                    resolve(true);
                    return true;
                }
            })
        });

    }
}
